import { ListItemIcon as MuiListItemIcon } from '@mui/material';
import { type ListItemIconProps as MuiListItemIconProps, styled } from '@mui/material';
import React, { type JSX } from 'react';

import { type IconSize, iconSlot } from '../icons/iconSlot';

export type ListItemIconProps = MuiListItemIconProps & {
    /** The px size of an icon placed directly in it; 16 by default. */
    iconSize?: IconSize;
};

/** MUI's ListItemIcon, sizing an icon placed directly in it; lumiquote-frontend's lint bans MUI's own. */
export const ListItemIcon = React.forwardRef(function ListItemIcon(
    { iconSize = 16, ...props }: ListItemIconProps,
    ref: React.ForwardedRef<HTMLDivElement>,
): JSX.Element {
    return <SizedListItemIcon ref={ref} iconSize={iconSize} {...props} />;
});

const SizedListItemIcon = styled(MuiListItemIcon, {
    shouldForwardProp: (prop) => prop !== 'iconSize',
})<{ iconSize: IconSize }>(({ iconSize }) => ({
    minWidth: 32,
    paddingLeft: '16px',
    ...iconSlot(iconSize),
}));
